import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { BusBulkEnrollService } from 'src/app/buses/_services/bus-bulk-enroll.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-upload-enroll-file',
  templateUrl: './upload-enroll-file.component.html',
  styleUrls: ['./upload-enroll-file.component.scss']
})
export class UploadEnrollFileComponent {
  destroy$ = new Subject<void>();

  currLang

  selectedFile: File | null = null;
  upload_state:string = "not-uploading"
  uploaded_data:any;
  constructor(
    private globalService: GlobalService,
    private translate: TranslateService,
    private errorMsgService: ErrorMsgService,
    private router: Router,
    private busBulkEnrollService: BusBulkEnrollService
  ) {

  }
  ngOnInit(): void {
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      this.currLang = lng;
    });
    this.globalService.getNotifyViewWithBulkEnrollState().pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.upload_state = res;
    })
    this.globalService.getBulkBusEnroll().pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.uploaded_data = res?.data;
    });
  }



  onExcelFileSelected(file: any) {
  if (file === 'not-supported') {
    this.errorMsgService.setMessage(
      this.translate.instant('buses.bulk-enroll.upload-step.file-not-supported')
    );
    this.selectedFile = null;
  } else if (file) {
    this.selectedFile = file;
  } else {
    this.selectedFile = null;
  }
}


  downloadTemplate() {
    const fileUrl = 'assets/files/BlueRide_bus_enroll_template.xlsx';

    // Create a temporary anchor element
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = 'BlueRide_Bus_students_template.xlsx'; // optional: set the filename for download
    a.style.display = 'none';
  
    // Append to the document, trigger click, and remove
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  uploadFile() {
    this.upload_state = 'uploading';
    this.globalService.setBulkEnrollNotificationState('uploading');
    this.globalService.setNotifyViewWithBulkEnrollState('uploading');
    const formData = new FormData();
    formData.append('file', this.selectedFile);
    this.busBulkEnrollService.importStudentsToBus(formData).subscribe((res:any)=>{
      this.globalService.setCurrentBusBulkEnrollBatchId(res?.data?.batch_id);
      // this.router.navigate(['buses/bulk-enroll/fix-errors']);
    },(err:any)=>{
      this.errorHandler(err);
    })
  }

  errorHandler(err:any){
    this.upload_state = 'not-uploading';
    this.globalService.setBulkBusEnroll('');
    this.globalService.setBulkEnrollNotificationState('');
    this.selectedFile = null;
    if(err?.error?.error_type == 'file_header_error'){
      this.errorMsgService.setMultibleLinesConfig({
        lineConfig: [
          { translationKey: 'buses.bulk-enroll.upload-step.errors.file-header-error.title', type: 'title' },
          { translationKey: 'buses.bulk-enroll.upload-step.errors.file-header-error.description', type: 'description' },
          { translationKey: 'buses.bulk-enroll.upload-step.errors.file-header-error.first_column', type: 'bold-description' },
          { translationKey: 'buses.bulk-enroll.upload-step.errors.file-header-error.second_column', type: 'bold-description' }
        ],
        multibleLines: true
      });
    }
    else if(err?.error?.error_type == 'file_content_error'){
      this.errorMsgService.setMessage(err?.error?.message)
    }
    else if(err?.error?.error_type == 'file_processing_error'){
      this.errorMsgService.setMessage(
        this.translate.instant('buses.bulk-enroll.upload-step.errors.file-processing-error')
      );
    }
    else if(err?.error?.errors?.file){
      this.errorMsgService.setMessage(
        this.translate.instant(err?.error?.errors?.file[0])
      );
    }
    else {
      this.errorMsgService.setMessage(err?.error?.message)
    }
  }

  ngOnDestroy(): void {
    this.errorMsgService.setMessage('');
  }
}
